<template>
	<modal :id="ref" :ref="ref" :closeProp="close" title="Membro" id_donor="">
		<form :id="refForm" :ref="refForm">
			<form-input readonly label="Nome" :value="getValue('first_name')"></form-input>

			<form-input readonly label="Cognome" :value="getValue('last_name')"></form-input>

			<form-textarea
				name="messaggio_socio"
				id="messaggio_socio"
				placeholder="Messaggio socio"
				label="Messaggio"
				:value="getValue('messaggio_socio')"
			></form-textarea>

			<!--CODICE ORIGINALE, SOLO DISPLAY IMMAGINE  ********
			<label>File</label>
			<a class="image_preview" :href="getValue('profile_url')" target="_blank"
				><img :src="getValue('profile_url')"
			/></a>

			REMOVE PREVIEW
			<div>
				<div>
					<a class="image_preview" :href="getValue('profile_url')" target="_blank">
						<img :src="getValue('profile_url')" id="image_to_remove" />
					</a>
					<input type="file" v-on:change="removePreview" />
				</div>
			</div>
			********-->

			<!--CODICE CORRETTO ************-->
			<!--<span>{{ completeRouteDelete }}</span>-->

			<label>File</label>
			<label
				class="image_preview"
				for="open_img"
				style="padding: 0; cursor: pointer; line-height: 200px; text-align: center"
			>
				<p
					v-if="display_profile_image.length == 0 && getValue('profile_url').length == 0"
					style="display: inline-block; vertical-align: middle; line-height: normal"
				>
					Nessuna immagine selezionata
				</p>
				<img v-else-if="display_profile_image.length > 1" :src="display_profile_image" />

				<img v-else :src="getValue('profile_url')" id="image_to_remove" />
			</label>

			<div style="margin-bottom: 25px">
				<label class="custom-upload">
					<input type="file" @change="changeimg($event)" name="path" id="open_img" />
					Carica immagine
				</label>

				<button
					v-if="getValue('profile_url').length > 0"
					class="delete_button"
					type="button"
					@click="deleteImage"
				>
					Elimina immagine
				</button>
			</div>

			<form-segment
				label="Approvato"
				name="approved"
				:options="[
					{ label: 'Si', value: '1' },
					{ label: 'No', value: '0' },
				]"
				:value="
					getValue('approved') === false || getValue('approved') === 'false'
						? '0'
						: getValue('approved') == true
						? '1'
						: ''
				"
				required
			></form-segment>

			<form-segment
				label="VIP"
				name="vip"
				:options="[
					{ label: 'Si', value: '1' },
					{ label: 'No', value: '0' },
				]"
				:value="getValue('vip', false) ? '1' : '0'"
				required
			></form-segment>
		</form>

		<template v-slot:footer>
			<btn type="success" :icon="['far', 'check']" title="Salva" :action="submitForm"></btn>
		</template>
	</modal>
</template>

<style>
.delete_button {
	background-color: #d9534f;
	color: white;
	text-align: center;
	font-weight: 400;
	font-size: 14px;
	border-radius: 4px;
	border: none;
	padding: 6px 18px;
	display: inline-block;
	float: right;
}

input[type='file'] {
	display: none;
}

.custom-upload {
	color: white;
	background-color: #0094f0;
	padding: 6px 12px;
	border-radius: 4px;
	display: inline-flex;
	overflow: hidden;
	align-items: center;
	justify-content: flex-start;
	margin: 0;
	font-size: 1rem;
	cursor: pointer;
}
</style>

<script>
export default {
	data: () => ({
		ref: 'members_modal',
		refForm: '',
		urlupdate: '',
		id: '',
		datas: {},
		display_profile_image: '',
	}),

	props: {
		reftable: {
			type: String,
			default: '',
			required: false,
		},
		delete_image: {
			type: String,
			required: false,
		},
	},

	/*computed: {
		completeRouteDelete: function() {
			//var variabile = "route('slides.goup', ['slide'=> $slide])"
			var route = this.delete_image
			route = route.replace('id_member', this.datas['id'])
			return route
		},
	},*/

	created: function () {
		this.refForm = this.ref + 'DataForm'
	},

	methods: {
		close: function () {
			this.assignData({})
			this.urlupdate = ''

			this.$refs[this.ref].close()
		},
		open: function (data) {
			if (!!data && typeof data === 'object') {
				if (!!data.urlupdate) this.urlupdate = data.urlupdate
				if (!!data.datas) this.assignData(data.datas)
			} else if (!!data && Array.isArray(data)) {
				this.assignData(data)
			} else {
				this.assignData({})
			}
			this.display_profile_image = ''
			this.$refs[this.ref].open()
		},
		getValue: function (key, defaultValue) {
			if (key === '') return this.datas
			else if (!!this.datas[key]) return this.datas[key]
			else if (this.datas[key] === 0 || this.datas[key] === '0' || this.datas[key] === false)
				return this.datas[key]
			else if (!!defaultValue) return defaultValue
			else return ''
		},
		assignData: function (datas) {
			if (!datas) return false

			if (!!Object.keys(datas).length) {
				this.datas = datas
				if (!!datas.id) this.id = datas.id
			} else {
				this.datas = {}
				this.id = ''
			}
		},
		submitForm: function () {
			var params = this.$root.getParamsFromForm(this.$refs[this.refForm])

			if (
				params['messaggio_socio'] == '' &&
				this.getValue('profile_url').length == 0 &&
				this.display_profile_image.length == 0
			) {
				alert("L'immagine e il Messaggio non possono essere entrambi vuoti")
				return
			}

			return this.$root.request(
				this,
				this.urlupdate,
				'POST',
				this.$root.getParamsFromForm(this.$refs[this.refForm]),
				this.submitFormCallback,
				{
					'Content-Type': 'multipart/form-data',
				}
			)
		},

		submitFormCallback: function (data) {
			if (!!this.reftable) this.$root.tableRefresh(this.reftable)

			this.close()
		},

		//ELIMINO IMMAGINE
		deleteImage() {
			//console.log('DELETE immagine')

			var route = this.delete_image
			route = route.replace('id_member', this.datas['id'])

			this.datas['profile_url'] = ''

			return this.$root.request(this, route, 'DELETE')
		},

		// PREVIEW IMMAGINE BIANCA QUANDO SELEZIONO IL FILE
		removePreview() {
			//console.log('cambio immagine')
			var image_x = document.getElementById('image_to_remove')
			image_x.parentNode.removeChild(image_x)
		},

		// CAMBIO PREVIEW IMMAGINE QUANDO SELEZIONO IL FILE
		changeimg(e) {
			let files = e.target.files || e.dataTransfer.files
			let reader = new FileReader()

			//Vue.set(display, 'preview', URL.createObjectURL(files[0]))
			this.display_profile_image = URL.createObjectURL(files[0])
			reader.readAsDataURL(files[0])
		},
	},
}
</script>
